<script>
    export let employee;
    export let status;

    import { approve, reject } from "../http.js";
</script>

{#if status != 'APPROVED'}
    <input type="submit" class="button is-success has-text-weight-bold my-2" on:click="{approve(employee)}"
        name="approve" id="approve" value="Zaakceptuj" disabled='{status == 'NOSELECTED'}'>
{/if}

{#if status != 'REJECTED'}
    <input type="submit" class="button is-danger has-text-weight-bold my-2" on:click="{reject(employee)}"
        name="reject" id="reject" value="Odrzuć" disabled='{status == 'NOSELECTED'}'>
{/if}
